export default "__VITE_ASSET__DvSoCzYT__"